export async function fetchShopOptionsCounting(shopId: string): Promise<any> {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/shops/${shopId}/option/counting`,
    {},
  );

  if (!res.ok) {
    return undefined;
  }

  return await res.json();
}
